'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('./constants');

var ActionTypes = _interopRequireWildcard(_constants);

var _actions = require('./actions');

var _isArray = require('./isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var nprogressMetaKey = '__nprogress__';
var resultActionTypeSuffixes = ['FULFILLED', 'REJECTED'];

var isNProgressResultAction = function isNProgressResultAction(type, fulfilled, rejected) {
  return type === fulfilled || type === rejected;
};

var getNProgressMeta = function getNProgressMeta(type, nprogress, configSuffixes) {
  if ((0, _isArray2.default)(nprogress)) {
    return nprogress;
  }

  var suffixes = nprogress.resultActionTypeSuffixes || configSuffixes;

  return suffixes.map(function (suffix) {
    return type + '_' + suffix;
  });
};

var isNProgressMetaAction = function isNProgressMetaAction(type, meta) {
  return meta && meta[nprogressMetaKey] && isNProgressResultAction.apply(undefined, [type].concat(_toConsumableArray(meta[nprogressMetaKey])));
};

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var suffixes = config.resultActionTypeSuffixes || resultActionTypeSuffixes;

  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        var type = action.type,
            meta = action.meta;


        var isMetaAction = isNProgressMetaAction(type, meta);
        var isNProgressAction = action.nprogress || isMetaAction;

        if (!isNProgressAction) {
          return next(action);
        }

        if (action.nprogress) {
          var nprogress = action.nprogress,
              actionProps = _objectWithoutProperties(action, ['nprogress']);

          dispatch((0, _actions.beginTask)());

          return next(_extends({}, actionProps, {
            meta: _extends({}, meta, _defineProperty({}, nprogressMetaKey, getNProgressMeta(type, nprogress, suffixes)))
          }));
        }

        if (isMetaAction) {
          var _action$meta = action.meta,
              __nprogress__ = _action$meta.__nprogress__,
              metaProps = _objectWithoutProperties(_action$meta, ['__nprogress__']),
              _actionProps = _objectWithoutProperties(action, ['meta']);

          var hasMeta = Object.keys(metaProps).length > 0;
          var actionMeta = hasMeta ? { meta: metaProps } : {};

          dispatch((0, _actions.endTask)());

          return next(_extends({}, _actionProps, actionMeta));
        }

        return next(action);
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/middleware.js
// module id = 1094
// module chunks = 2